import UpdateAttachmentForm from './update-attachment-form'

export default UpdateAttachmentForm;